@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

.percentage-input {
  align-items: center;
  color: var(--default--input--text-color--1);
  display: flex;
  height: 42px;
  position: relative;

  input {
    background: var(--light--input--background-color--1);
    border-radius: 4px;
    border: 1px solid var(--default--input--border-color--1);
    font-size: 14px;
    height: 100%;
    line-height: 20px;
    padding: 0 22px 0 10px;
    resize: none;
    text-align: right;
    width: 100%;

    &:disabled {
      background-color: var(--default--input--disabled--background-color--1);
      border-color: var(--default--input--disabled--background-color--2);
    }

    &:focus {
      border-color: var(--default--input--text-color--1);
    }

    &:invalid {
      border: 1px solid var(--error--input--border-color--1);
    }
  }

  &:before {
    content: '%';
    position: absolute;
    top: 2px;
    right: 7px;
    font-weight: 700;
    line-height: 37px;
    border-radius: 4px;
  }
}
